// extracted by mini-css-extract-plugin
export default {"list09":"index_list09_5CHA-","boxT":"index_boxT_h7Nf2","boxB":"index_boxB_A2U1P","textBg":"index_textBg_IY-4T","text":"index_text_y920a","tt":"index_tt_9bldi"};